module.exports = __webpack_public_path__ + "img/card_movs.bf3ced74.png";